import type { CommonArea } from '@pigello/pigello-matrix';
import { withBuildingRealEstate } from './shared-building-realestate';
import type { TCustomList } from './types';

export async function handleCustomCommonAreaNestedCase(
  listResponse: TCustomList<CommonArea>
) {
  return withBuildingRealEstate(listResponse);
}
